import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import blogService from '../../services/blogService';

// Async thunks for public blog operations (JetSetter users)
export const fetchBlogs = createAsyncThunk(
  'blog/fetchBlogs',
  async (params, { rejectWithValue }) => {
    try {
      const response = await blogService.getBlogs(params);
      return response;
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to fetch blogs');
    }
  }
);

export const fetchBlogBySlug = createAsyncThunk(
  'blog/fetchBlogBySlug',
  async (slug, { rejectWithValue }) => {
    try {
      console.log('fetchBlogBySlug: Fetching blog with slug:', slug);
      const response = await blogService.getBlogBySlug(slug);
      console.log('fetchBlogBySlug: Response received:', response);
      return response.data || response;
    } catch (error) {
      console.error('fetchBlogBySlug: Error:', error);
      return rejectWithValue(error.message || 'Failed to fetch blog');
    }
  }
);

// Initial state
const initialState = {
  blogs: [],
  currentBlog: null,
  pagination: {
    current_page: 1,
    per_page: 10,
    total: 0,
    total_pages: 1
  },
  loading: false,
  error: null
};

// Public blog slice
const blogSlice = createSlice({
  name: 'blog',
  initialState,
  reducers: {
    clearBlogError: (state) => {
      state.error = null;
    },
    resetCurrentBlog: (state) => {
      state.currentBlog = null;
    }
  },
  extraReducers: (builder) => {
    builder
      // Fetch All Blogs
      .addCase(fetchBlogs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBlogs.fulfilled, (state, action) => {
        state.blogs = action.payload.data || [];
        state.pagination = {
          current_page: action.payload.currentPage || 1,
          total_pages: action.payload.totalPages || 1,
          total: action.payload.total || 0,
          per_page: state.pagination.per_page
        };
        state.loading = false;
        state.error = null;
      })
      .addCase(fetchBlogs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Fetch Blog By Slug
      .addCase(fetchBlogBySlug.pending, (state) => {
        console.log('blogSlice: fetchBlogBySlug.pending');
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBlogBySlug.fulfilled, (state, action) => {
        console.log('blogSlice: fetchBlogBySlug.fulfilled', action.payload);
        state.currentBlog = action.payload.content || action.payload;
        state.loading = false;
        state.error = null;
      })
      .addCase(fetchBlogBySlug.rejected, (state, action) => {
        console.error('blogSlice: fetchBlogBySlug.rejected', action.payload);
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { clearBlogError, resetCurrentBlog } = blogSlice.actions;
export default blogSlice.reducer;
